import React, { forwardRef }  from 'react';
import { formatDistanceToNow, parseISO } from 'date-fns';
import frLocale from 'date-fns/locale/fr';
import { motion } from "framer-motion"; // useAnimation
import Grid from "@mui/material/Grid";

import CenteredBlogCard from "dashboard/examples/Cards/BlogCards/CenteredBlogCard";
import DefaultReviewCard from "dashboard/examples/Cards/ReviewCards/DefaultReviewCard";

// animation config and variants
const tween = {
  type: "tween",
  ease: "easeInOut"
};

/* eslint-disable */
const ProductCard = forwardRef(({view,product,parseContent, size, cardtype, color,reactLoading, handleLikeProduct,  setSelectedProduct, reactions,likedAlready,isPartner,updateProduct, isLoading,dist_id, ...motionProps}, ref) => {
  const fadeFromBottom = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "tween",
        ease: "easeInOut"
      },
    },
  };
  const productShow = ()=>{
    setSelectedProduct(product)
  }
  return (
    <Grid key={product.id} xs={view ? 12 : size.xs} md={size.md} lg={view ? 6 :size.lg} xl= {view ? 6 : size.xl}  item>
      <motion.div
        initial={fadeFromBottom.hidden}
        whileInView={fadeFromBottom.visible}
        ref={ref}
        viewport={{ once: true }}
        layout
        layoutId={`card-container--index-${product.id}`}
        transition={tween}
        {...motionProps}
        >
          {cardtype === "standard" ? (
              <CenteredBlogCard
                  image={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${product.selectedImage}`}
                  title={product.productName}
                  // description={parse(DOMPurify.sanitize(product.description))}
                  action={{
                    type: "internal",
                    route: `/product/${product.id}`,
                    color: color,
                    label: "Plus de details",
                  }}
                  date={formatDistanceToNow(parseISO(product.createdAt),{locale: frLocale})}
                  price={product.priceShow}
                  priceSold={product.price.sold}
                  priceOrigin={product.price.original}
                  category={product.category?.name || "Autres"}
                  id={product.id}
                  color={color}
                  setSelectedProduct={productShow}
                  handleLikeProduct={handleLikeProduct}
                  view={view}
                  reactions={reactions}
                  likedAlready={likedAlready}
                  isPartner={isPartner}
                  updateProduct={updateProduct}
                  isLoading={isLoading}
                  dist_id={dist_id}
              />
          ):(
              <DefaultReviewCard
                  image={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${product.selectedImage}`}
                  color={color}
                  id={product.id}
                  name={product.productName}
                  date={formatDistanceToNow(parseISO(product.createdAt),{locale: frLocale})}
                  review={parseContent(product.description)}
                  price={product.priceShow}
                  category={product.category?.name || "Autres"}
                  priceSold={product.price.sold}
                  priceOrigin={product.price.original}
                  setSelectedProduct={productShow}
                  handleLikeProduct={handleLikeProduct}
                  view={view}
                  reactions={reactions}
                  likedAlready={likedAlready}
                  route={`/product/${product.id}`}
                  isPartner={isPartner}
                  updateProduct={updateProduct}
                  isLoading={isLoading}
                  dist_id={dist_id}
              />
          )}
        </motion.div>
    </Grid>
  )
});

export default ProductCard